module.exports = __webpack_public_path__ + "static/img/fwqm.39edcc9e.png";